import React from 'react'

export default () => {}

export const DatsJobBaseContext = React.createContext({})

export function DatsJobBaseContextProvider({ value, children }) {
  return <DatsJobBaseContext.Provider value={value}>{children}</DatsJobBaseContext.Provider>
}
